import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
  effect,
} from '@angular/core';
import { FormControlDynamicComponent } from '@form';
import { FormBuilder } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'ui-filters-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormControlDynamicComponent],
  template: `
    <div class="flex justify-between gap-x-2 bg-white rounded-full px-4 py-1.5">
      <ng-content></ng-content>
      <form-control type="switch" label="Filter switch" [control]="control" />
    </div>
  `,
})
export class FilterSwitchComponent {
  private fb = inject(FormBuilder);
  selected = input<boolean>()
  // When true, the form control is disabled
  disabled = input<boolean>(false);

  control = this.fb.control(this.selected() || true);
  onCheck = output<boolean>();

  constructor() {
    this.control.valueChanges
      .pipe(takeUntilDestroyed(), distinctUntilChanged())
      .subscribe((checked) => {
        this.onCheck.emit(!!checked);
      });

    // react to disabled signal and enable/disable the underlying FormControl
    effect(() => {
      if (this.disabled && this.disabled()) {
        this.control.disable({ emitEvent: false });
      } else {
        this.control.enable({ emitEvent: false });
      }
    });
  }
}
